export default {"src":"/_next/static/media/quote.6ccaf732.svg","height":34,"width":42,"blurWidth":0,"blurHeight":0};